export const getPageSeoTitle = (
  title?: string,
  seoTitle?: string,
  internalName?: string
): string | undefined => {
  const isValidString = (str?: string): str is string =>
    typeof str === "string" && str.trim().length > 0;

  if (isValidString(seoTitle)) {
    return seoTitle.trim();
  }

  if (isValidString(title)) {
    return title.trim();
  }

  if (isValidString(internalName)) {
    return internalName.trim();
  }

  return undefined;
};
